exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table th[data-v-4d2aa6da]{border-top:none;font-weight:600;color:#495057}.table td[data-v-4d2aa6da]{vertical-align:middle}.table code[data-v-4d2aa6da]{background:#f8f9fa;padding:2px 6px;border-radius:3px;font-size:.9em}.btn-group .btn[data-v-4d2aa6da]{margin-right:2px}.btn-group .btn[data-v-4d2aa6da]:last-child{margin-right:0}@media (max-width:768px){.agent-corp-mail-manager[data-v-4d2aa6da]{padding:10px}.table-responsive[data-v-4d2aa6da]{font-size:.9em}.btn-group[data-v-4d2aa6da]{display:flex;flex-direction:column}.btn-group .btn[data-v-4d2aa6da]{margin-bottom:2px;margin-right:0}}", ""]);

// exports
